import React from 'react'
import TransactionReportList from '../../../features/Financials/TransactionReportList/TransactionReportList'

const TransactionReport = () => {
  return (
    <div><TransactionReportList/></div>
  )
}

export default TransactionReport